interface RedirectSpanLinkProps {
  onClick: () => void;
}
const RedirectSpanLink = ({ onClick }: RedirectSpanLinkProps) => (
  <span
    onClick={onClick}
    style={{ cursor: 'pointer', textDecoration: 'underline' }}
  >
    here
  </span>
);

export default RedirectSpanLink;
